<template lang="pug">
    .card-teaser(v-if="display === 'card'" :class="{ hover: mouseover }")
        router-link(
            :to="path"
            @mouseover.native="hover"
            @mouseleave.native="blur"
        )
            figure
                img(v-if="showImage" v-lazy="image" :alt="altText")
                h3.is-size-4(v-if="title")
                    | {{ title }}
</template>

<script>

import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'
import striptags from 'striptags'
// import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Teaser',
    data() {
        return {
            delay: 150,
            mouseover: false,
            showImage: true,
        }
    },
    props: {
        teaser: {
            type: Object,
            required: true,
        },
        display: {
            type: String,
            default: 'row',
        },
    },
    watch: {
        image() {
            // ugly workaround
            this.showImage = false
            this.$nextTick(() => {
                this.showImage = true
            })
        },
    },
    computed: {
        image() {

            let image

            if (this.teaserSection) {
                const content = this.teaserSection.contents.find(content => content.key === 'image')
                if (content && content.images.length) image = content.images[0]
            }

            if (! image && this.sections.length) {
                this.sections.forEach(section => {
                    if (image) return

                    const content = section.contents.find(content => content.key === 'image')
                    if (content && content.images.length) image = content.images[0]
                })
            }

            if (! image) return false

            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1'
            const parameters = {
                // ... get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            let width, height
            let aspectRatio = 4 / 5

            height = 450
            width = height * aspectRatio

            if (w && h) {
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`)
            } else if (! w && ! h) {
                fit += `&w=${width}&h=${height}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },



        path() {
            const categoryKey = _.get(this.teaser, 'category.key')
            const key = this.teaser.key

            let categoryPath
            switch (categoryKey) {
                case 'models':
                    categoryPath = `/models/${key}`
                    break;

                case 'newfaces':
                    categoryPath = `/newfaces/${key}`
                    break;
            }

            return categoryPath
        },
        topic() {
            return get(this.teaser, 'category.name')
        },
        title() {
            return get(this.teaser, 'title')
        },
        altText() {
            return 'Model - ' + get(this.teaser, 'title');
        },
        text() {
            let content
            if (this.teaserSection) {
                content = this.teaserSection.contents.find(content => content.key === 'teaser')
            }
            if ( content ) {
                if (! (content && content.text) && this.postSection) {
                    content = this.postSection.contents.find(content => content.key === 'content')
                }
            }else return null;

            return content.text
        },
        sections() {
            return this.teaser.sections
        },
        teaserSection() {
            return this.sections.find(section => section.key === 'category-page-teaser')
        },
        postSection() {
            return this.sections.find(section => section.key === 'post')
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
        striptags(html) {
            html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />')
            return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br'])
        }
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'

    .card-teaser, .row-teaser
        text-align: initial
        h3
            position: absolute
            bottom: 0
            width: 100%
            text-align: center
            color: #fff
            line-height: 1.3
            padding: 5px
            backdrop-filter: blur(10px) opacity(0.8)
        p.topic
            font-size: .85rem
            margin-bottom: 10px
        .bait
            margin-bottom: 10px
            word-break: normal !important
            br + br
                display: none
        figure
            position: relative
            width: 100%
            padding-bottom: 125%
            display: block
            background: $skeletonColor
            border-radius: 3px
            margin-bottom: 20px
            transition: transform .8s ease
            img
                border-radius: 3px
                position: absolute
                width: 100%
                max-height: 100%
                left: 0
                top: 0
                box-shadow: $box-shadow-2
                transition: box-shadow .8s ease
        &.hover
            a figure
                transform: scale(1.04)
                img
                    box-shadow: $box-shadow-3
    +tablet
        .row-teaser
            display: flex
            flex-direction: row
            .image
                flex-basis: 320px
                flex-grow: 0
                flex-shrink: 0
                figure
                    margin-bottom: 0
            .text
                margin-left: 20px
                flex-grow: 1
                display: flex
                flex-direction: column
                .bait
                    flex-grow: 1
</style>
